import { ScopeLevel } from '@bingads-webui-campaign-react/constants';

export const getSummary = (level, data, i18n) => {
  let parentToggleDescription = '';
  if (!data) return '';

  if (level === ScopeLevel.AdGroup) {
    parentToggleDescription = data.useParentLevel ? i18n.getString(_TL_('Use campaign settings: ')) : '';
  }

  const bidAdjustment = data.useParentLevel ? data.parentLevelData.bidAdjustmentInput : data.currentLevelData.bidAdjustmentInput;
  return parentToggleDescription + i18n.getString(_TL_('Increase bids by {{bidAdjustment}}%'), { bidAdjustment });
};

export const RANGE = {
  min: 20,
  max: 900,
};
